import { freeze, merge, set, chain } from 'icepick';
import { SET_APP_DATA, type SetAppDataAction } from '../../../actions/app/index.tsx';
import {
	ISSUE_PARENTS_CREATE_SET,
	type IssueParentsCreateSetAction,
} from '../../../actions/issue-parents/create/index.tsx';
import {
	type LoadIssueParentsSuccessAction,
	LOAD_ISSUE_PARENTS_SUCCESS,
} from '../../../actions/issue-parents/load/index.tsx';
import {
	type IssueParentPatchAction,
	ISSUE_PARENT_PATCH,
} from '../../../actions/issue-parents/patch/index.tsx';
import type { IssueParentsEntityState } from './types.tsx';

type Action =
	| SetAppDataAction
	| LoadIssueParentsSuccessAction
	| IssueParentsCreateSetAction
	| IssueParentPatchAction;

const defaultState: IssueParentsEntityState = {};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	state: IssueParentsEntityState = defaultState,
	action: Action,
): IssueParentsEntityState => {
	switch (action.type) {
		case SET_APP_DATA: {
			const {
				payload: {
					entities: { issueParents },
				},
			} = action;

			return issueParents ? freeze(issueParents) : state;
		}

		case ISSUE_PARENTS_CREATE_SET:
		case LOAD_ISSUE_PARENTS_SUCCESS: {
			const { issueParents } = action.payload;
			const chainedState = chain(state);

			issueParents.forEach((issueParent) => {
				chainedState.set(String(issueParent.id), issueParent);
			});

			return chainedState.value();
		}

		case ISSUE_PARENT_PATCH: {
			const { issueParent, id } = action.payload;
			const oldParent = state[id];

			if (!oldParent) {
				return state;
			}

			return set(state, id, merge(oldParent, issueParent));
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
